import type { LocaleType } from './Locale';
import { isLocaleType } from './Locale';

export function convertIetfLanguageTagToLocale(
  ietf?: string,
): LocaleType | undefined {
  let locale: LocaleType | undefined;
  if (ietf) {
    try {
      const c = ietf.split('-')[0];
      if (isLocaleType(c)) {
        locale = c;
      }
    } catch {}
  }
  return locale;
}
